import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {isPrivateSeller} from './isPrivateSeller';

export type StatisticsChartSellerOption = {
  value: string;
  label: string;
};

export function getStatisticsChartSellerOptions(
  cars: ExtendedStatisticsCar[]
): StatisticsChartSellerOption[] {
  const optionsByKey = new Map<string, StatisticsChartSellerOption>();

  for (const car of cars) {
    const seller = car.seller;

    if (!seller?.id || isPrivateSeller(car)) {
      continue;
    }

    const label = seller.name ?? seller.address;

    if (!label) {
      continue;
    }

    optionsByKey.set(seller.id, {value: seller.id, label});
  }

  return [...optionsByKey.values()].sort((left, right) => left.label.localeCompare(right.label));
}
